
@if (authService.loggedIn()) {
  @if (testing.layout() === 'flat') {
    <tps-flat-layout />
  } @else {
    <tps-main-layout />
  }
} @else {
  <tps-login />
}
